/**
 * Horizontal scroll container for data tables. On a phone a wide table
 * scrolls inside its card instead of pushing the page wider than the
 * screen ("bleeding"). Use around every <table> in ops2026.
 */
import type { ReactNode } from 'react';

export function TableScroll({ children, minWidth }: { children: ReactNode; minWidth?: number }): JSX.Element {
  return (
    <div
      style={{
        width: '100%',
        maxWidth: '100%',
        overflowX: 'auto',
        WebkitOverflowScrolling: 'touch',
      }}
    >
      <div style={minWidth !== undefined ? { minWidth } : undefined}>{children}</div>
    </div>
  );
}
